/*付款审批 */
import { $http, buildHeaders } from "./index";

//#region 采购审批

//获取列表
export const meetingpurchasepaymentapply_page = (params) => {
  return $http.get("/admin/MeetingPurchasePaymentApply/index", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取待审批详情
export const meetingpurchasepaymentapply_detail = (id) => {
  return $http.get(
    "/admin/MeetingPurchasePaymentApply/read",
    { params: { id } },
    {
      headers: buildHeaders(3, "数据加载中，请稍后……"),
    },
  );
};

//获取已审批详情
export const meetingpurchasepaymentapply_search = (id) => {
  return $http.get(
    "/admin/MeetingPurchasePaymentApply/detail",
    { params: { id } },
    {
      headers: buildHeaders(3, "数据加载中，请稍后……"),
    },
  );
};

//审批
export const meetingpurchasepaymentapply_approve = (data) => {
  return $http.post("/admin/MeetingPurchasePaymentApply/approve", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//确认付款
export const meetingpurchasepaymentapply_pay = (data) => {
  return $http.post("/admin/MeetingPurchasePaymentApply/pay", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//#endregion

//#region 无采购审批

//获取列表
export const supplierpaymentapply_page = (params) => {
  return $http.get("/admin/SupplierPaymentApply/index", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取待审批详情
export const supplierpaymentapply_detail = (id) => {
  return $http.get(
    "/admin/SupplierPaymentApply/read",
    { params: { id } },
    {
      headers: buildHeaders(3, "数据加载中，请稍后……"),
    },
  );
};

//获取已审批详情
export const supplierpaymentapply_search = (id) => {
  return $http.get(
    "/admin/SupplierPaymentApply/detail",
    { params: { id } },
    {
      headers: buildHeaders(3, "数据加载中，请稍后……"),
    },
  );
};

//审批
export const supplierpaymentapply_approve = (data) => {
  return $http.post("/admin/SupplierPaymentApply/approve", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//确认付款
export const supplierpaymentapply_pay = (data) => {
  return $http.post("/admin/SupplierPaymentApply/pay", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//#endregion
